import { useEffect, useState, type ReactNode } from 'react';

import { Mask, Text, type TextVariant, useViewport } from '@farmersdog/corgi-x';

import styles from './PlanStep.css';

export interface PlanStepProps {
  step: number;
  title: ReactNode;
  description: ReactNode;
}

export function PlanStep({ step, title, description }: PlanStepProps) {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const viewport = useViewport();
  const isLargeViewport = hasMounted && viewport.lg;

  const titleVariant: TextVariant = isLargeViewport
    ? 'heading-40'
    : 'heading-22';

  return (
    <li className={styles.item}>
      <Mask shape="circle" size="sm">
        <Text
          variant="heading-22"
          color="white"
          as="span"
          className={styles.step}
        >
          {step}
        </Text>
      </Mask>
      <Text
        className={styles.title}
        variant={titleVariant}
        weight="bold"
        as="h3"
        color="kale-3"
      >
        {title}
      </Text>
      <Text
        className={styles.description}
        variant="article-16"
        as="p"
        color="charcoal-3"
      >
        {description}
      </Text>
    </li>
  );
}
